import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class UpdateSabitlerAPI extends BaseAPI {

  constructor() {
    const baseUrl = environment.API_URL  + 'UpdateSabitler/guncelle';
    super(baseUrl);
  }

  postUpdateSabitler(
    kurumId: number | null = null,
    gencisBorkontrolEh: string | null = null,
    basvuruAlindiDurumKodu: string | null = null,
    primaryColor: string | null = null,
    secondaryColor: string | null = null,
    thirdColor: string | null = null,
    fourthColor: string | null = null,
    errorColor: string | null = null,
    buttonVariant: string | null = null,
    themeMode: string | null = null,
    fontSize: number | null = null,
    kwMetni: string | null = null,
    sicilOlusturma: string | null = null,
    kullaniciKodu: string | null = null,
    guvenlikMetni: string | null = null,
    belediyeAdres: string | null = null,
    belediyeMail: string | null = null,
    belediyeTelefon: string | null = null,
    sicilTelKontrol: string | null = null,
    loginTelKontrol: string | null = null,
    tahsilatAp: string | null = null,
    ilMi: string | null = null,
    yeniAbonlkMesafeliSozlesmeBase64: string | null = null,
    devirBsvruMesafeliSozlesmeBase64: string | null = null
  ) {
    return this.post('', {
      'kurumId': kurumId,
      'gencisBorkontrolEh': gencisBorkontrolEh,
      'basvuruAlindiDurumKodu': basvuruAlindiDurumKodu,
      'primaryColor': primaryColor,
      'secondaryColor': secondaryColor,
      'thirdColor': thirdColor,
      'fourthColor': fourthColor,
      'errorColor': errorColor,
      'buttonVariant': buttonVariant,
      'themeMode': themeMode,
      'fontSize': fontSize,
      'kvkMetni': kwMetni,
      'sicilOlusturma': sicilOlusturma,
      'kullaniciKodu': kullaniciKodu,
      'guvenlikMetni': guvenlikMetni,
      'belediyeAdres':belediyeAdres,
      'belediyeMail':belediyeMail,
      'belediyeTelefon':belediyeTelefon,
      'sicilTelKontrol':sicilTelKontrol,
      'loginTelKontrol':loginTelKontrol,
      'tahsilatAp':tahsilatAp,
      'ilMi':ilMi,
      'yeniAbonlkMesafeliSozlesmeBase64':yeniAbonlkMesafeliSozlesmeBase64,
      'devirBsvruMesafeliSozlesmeBase64':devirBsvruMesafeliSozlesmeBase64
    }, false);
  }
}

export default new UpdateSabitlerAPI();
